module.exports = "build/assets/healthcare.91ebb60e.png";